// extracted by mini-css-extract-plugin
module.exports = {"form":"SetNewPasswordForm_form__3sA9H","form__submit":"SetNewPasswordForm_form__submit__1iup5"};